import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { pickBy, get } from 'lodash';
import { dateFormat } from '../../../config';
import { whoPaysMapping } from '../../../config/ift';
import { amountFormater } from '../ManagePaymentListing/ColumnFormater';
import PaymentDetailsContainer from './PaymentDetailsContainer';
import { directDebitPropTypes } from '../../../states/managePayments/propTypes';
import PaymentDetailsTable from './PaymentDetailsTable';
import { formatSortCode } from '../../../utils/accountUtils';

export const formatAmount = ({ value, currency }) => amountFormater({ amount: value, currency });

export const formatFrom = ({ name, account_number, sort_code }) =>
	`${name} ${formatSortCode(sort_code)} ${account_number}`;

export const formatTo = ({ name, account_number, iban }) => {
	if (iban) {
		return `${name} ${iban}`;
	}
	return `${name} ${account_number}`;
};

export const IFTDetails = ({ mandate, content }) => {
	const {
		fromLabel,
		toLabel,
		reasonPaymentLabel,
		amountSentLabel,
		debitAmountLabel,
		exchangeRateLabel,
		paymentFeesLabel,
		typeLabel,
		createdByLabel,
		estimatedSettlementLabel,
		paymentSubmissionLabel,
		createdOnLabel,
	} = content;

	const {
		mandateType,
		submissionDate,
		settlementDate,
		created_by,
		created_timestamp,
		exchangeRate,
		debitAmount,
		sendAmount,
		reference,
		paymentFees,
		from_account: fromAccount,
		to_account: toAccount,
		charging_model: chargingModel,
	} = mandate;
	const tableRowMapping = pickBy({
		[typeLabel]: mandateType,
		[fromLabel]: formatFrom(fromAccount),
		[toLabel]: formatTo(toAccount),
		[debitAmountLabel]: formatAmount(debitAmount),
		[paymentFeesLabel]: (
			<span>
				{formatAmount(paymentFees)} (
				{get(
					whoPaysMapping.find(({ id }) => id === chargingModel),
					'label'
				)}
				)
			</span>
		),
		[paymentSubmissionLabel]: submissionDate,
		[exchangeRateLabel]: exchangeRate,
		[amountSentLabel]: formatAmount(sendAmount),
		[estimatedSettlementLabel]: settlementDate,
		[reasonPaymentLabel]: reference,
		[createdByLabel]: created_by,
		[createdOnLabel]: created_timestamp && moment(created_timestamp).format(dateFormat),
	});
	return <PaymentDetailsTable tableRowMapping={tableRowMapping} />;
};

export default PaymentDetailsContainer(IFTDetails);

IFTDetails.propTypes = {
	mandate: PropTypes.shape(directDebitPropTypes),
	content: PropTypes.shape({}),
};
